export default "/images/gjensidige-min.png?704de6868f56f45d717558152b2f9e85";